import React from 'react';

import { Popup } from 'src/components/Popup/Popup';
import { observer } from 'mobx-react-lite';
import { ParticipantsInputGroupState, RoleObjectType } from './ParticipantsInputGroup.state';
import { ParticipantsInput, SelectValueType } from './ParticipantsInput';

interface PropsType {
    sport?: string;
    roles: false | Array<string>;
    onChange?: (value: RoleObjectType[]) => void;
}

export const ParticipantsInputGroup = observer((props: PropsType) => {
    const [stateMobx] = React.useState(() => new ParticipantsInputGroupState());

    const { roles, sport } = props;

    let inputs = null;

    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!sport) {
        return null;
    }

    if (Array.isArray(roles)) {
        inputs = (
            <div>
                {roles.map((role) => {
                    const v = stateMobx.twoParticipants.findByRole(role);

                    return (
                        <div
                            key={role}
                            className='element'
                        >
                            <strong>{role}:</strong>
                            <ParticipantsInput
                                sport={sport}
                                stateMobx={stateMobx}
                                selected={v?.participant}
                                onChange={(value: SelectValueType | null): void => {
                                    const newParticipants = stateMobx.twoParticipants.changeByRole(role, value);

                                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                    if (props.onChange) {
                                        props.onChange(newParticipants);
                                    }
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        );
    } else {
        inputs = (
            <div>
                {stateMobx.outrights.value.map((v, idx) => {
                    return (
                        <div
                            key={idx}
                            className='element'
                        >
                            <ParticipantsInput
                                sport={sport}
                                stateMobx={stateMobx}
                                selected={v}
                                onChange={(value: SelectValueType | null): void => {
                                    const newParticipants = stateMobx.outrights.changeByIdx(idx, value);

                                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                    if (props.onChange) {
                                        props.onChange(newParticipants);
                                    }
                                }}
                            />
                        </div>
                    );
                })}

                <div
                    key='new'
                    className='element'
                >
                    <ParticipantsInput
                        sport={sport}
                        stateMobx={stateMobx}
                        selected={null}
                        onChange={(value: SelectValueType | null): void => {
                            const newParticipants = stateMobx.outrights.addNew(value);

                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                            if (props.onChange) {
                                props.onChange(newParticipants);
                            }
                        }}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className='participants-input'>
            {inputs}

            <Popup
                priority={1000}
                overlayClose={true}
                onClose={stateMobx.closeModal}
                active={stateMobx.mode === 'add'}
                title='Add participant'
            >
                <input
                    type='text'
                    placeholder='Name'
                    value={stateMobx.newParticipantName}
                    onChange={stateMobx.changeNewParticipantName}
                />

                <a
                    href='#'
                    className='btn'
                    onClick={(): void => {
                        stateMobx.createParticipant(sport).catch((error) => {
                            console.error('error occurred while creating a participant', error);
                        });
                    }}
                >
                    Create
                </a>
            </Popup>

            {/* Tutaj dodać obsługę loadingu w momencie jak się tworzy partycypant */}
            {/* <Loading
                message='Creating participant...'
                active={ this.props.creationState === 'IN_PROGRESS' }
            /> */}
        </div>
    );
    // }
});
